import { render } from "./edit-bank-account-gateway.vue?vue&type=template&id=29b0b458"
import script from "./edit-bank-account-gateway.vue?vue&type=script&lang=js"
export * from "./edit-bank-account-gateway.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__